import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    orderOnFly: `${APP_CONFIG.care_cluster}/search-360/order/open`,
  },
}
